import React from 'react';
import { Route } from 'react-router-dom-v5-compat';

import HTTP401 from './HTTP401';
import HTTP403 from './HTTP403';
import HTTP404 from './HTTP404';

enum RoutePath {
  Unauthorized = '/unauthorized',
  Forbidden = '/forbidden',
  Default = '*',
}

const ErrorRoutes = [
  <Route key={RoutePath.Unauthorized} path={RoutePath.Unauthorized} element={<HTTP401 />} />,
  <Route key={RoutePath.Forbidden} path={RoutePath.Forbidden} element={<HTTP403 />} />,
  <Route key={RoutePath.Default} path={RoutePath.Default} element={<HTTP404 />} />,
];

export default ErrorRoutes;
